import { jsxs as t, jsx as r } from "react/jsx-runtime";
import { createContext as e, useState as o, useContext as a } from "react";
import { getDesignConfigName as i } from "./getDesignConfigName.js";
import s from "../../../patterns/atoms/grid/v1/Grid.js";
import n from "../../../patterns/molecules/snackbar/v1/SnackBar.js";
const d = 3e3, c = "soft", m = "md", p = e(void 0), u = () => {
  const t2 = a(p);
  if (!t2) throw new Error("useToast must be used within a ToastProvider");
  return t2;
}, l = ({ children: e2, defaultDuration: a2 }) => {
  const [u2, l2] = o([]), f = (t2) => {
    l2((r2) => r2.filter((r3) => r3.id !== t2));
  };
  return t(p.Provider, { value: { addToast: (t2, r2, e3 = a2 || d, o2 = c, i2 = "", s2 = "", n2 = m, p2 = {}) => {
    const u3 = crypto.randomUUID();
    l2((a3) => [...a3, { id: u3, message: t2, type: r2, duration: e3, variant: o2, startDecorator: i2, endDecorator: s2, size: n2, "data-testid": p2["data-testid"] }]), setTimeout(() => {
      f(u3);
    }, e3);
  } }, children: [e2, r(s, { container: true, flexDirection: "column", position: "absolute", top: 20, right: 10, minWidth: 350, gap: 1, "data-testid": "toast-context-provider", children: u2.map((t2) => r(n, { open: true, "data-testid": t2["data-testid"], designVariant: i(t2.variant ?? "soft", t2.size ?? "md", t2.type), sx: { position: "relative" }, startDecorator: t2.startDecorator, endDecorator: t2.endDecorator, children: t2.message }, t2.id)) })] });
};
export {
  l as ToastProvider,
  u as useToast
};
